var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightEnd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.202772 0.229221C0.473135 -0.0764069 0.91148 -0.0764069 1.18184 0.229221L5.79723 5.44661C6.06759 5.75224 6.06759 6.24776 5.79723 6.55339L1.18184 11.7708C0.91148 12.0764 0.473135 12.0764 0.202772 11.7708C-0.0675907 11.4652 -0.0675907 10.9696 0.202772 10.664L4.32862 6L0.202772 1.336C-0.0675907 1.03037 -0.0675907 0.534848 0.202772 0.229221Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.75C10 0.335786 9.66421 0 9.25 0C8.83579 0 8.5 0.335786 8.5 0.75V11.25C8.5 11.6642 8.83579 12 9.25 12C9.66421 12 10 11.6642 10 11.25V0.75Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightEnd);
export default __webpack_public_path__ + "static/media/arrow-right-end.76ef66bc26c07d93ee9644550ab7541e.svg";
export { ForwardRef as ReactComponent };